import React from 'react';
import { Box } from '@mui/material';
import { useAppSelector } from '../../store/hooks';
import { selectSidebarCollapsed } from '../../store/slices/uiSlice';
import { selectPartnerId } from '../../store/slices/authSlice';
import PartnerSidebar from './PartnerSidebar';
import PartnerTopNav from './PartnerTopNav';
import { useParams } from 'react-router-dom';

const PartnerLayout = ({ children }) => {
  const { partnerId: urlPartnerId } = useParams();
  const reduxPartnerId = useAppSelector(selectPartnerId);
  const isCollapsed = useAppSelector(selectSidebarCollapsed);
  
  // Use Redux partnerId as fallback if URL param is missing
  const partnerId = urlPartnerId || reduxPartnerId;

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: '#FFFFFF' }}>
      <PartnerSidebar 
        partnerId={partnerId}
      />
      <PartnerTopNav
        partnerId={partnerId}
        isCollapsed={isCollapsed}
      />
      <Box 
        component="main"
        sx={{ 
          flexGrow: 1, 
          pt: '80px', // Account for the top navigation bar
          pl: 0, // Remove left padding since sidebar is positioned absolutely
          pr: 0, // Remove right padding
          pb: 0, // Remove bottom padding
          bgcolor: '#FFFFFF',
          transition: 'width 0.3s cubic-bezier(0.4, 0, 0.2, 1), margin-left 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          marginLeft: `${isCollapsed ? '80px' : '280px'}`,
          width: `calc(100% - ${isCollapsed ? '80px' : '280px'})`,
        }}
      >
        <Box sx={{ p: 3 }}> {/* Re-apply padding to content */}
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default PartnerLayout;